import { application } from "./application"

import DateRangePickerController from "./daterangepicker_controller"
import AdModalController from "./ad_modal_controller"
import AdModalTriggerController from "./ad_modal_trigger_controller"

application.register("daterangepicker", DateRangePickerController)
application.register("ad-modal", AdModalController)
application.register("ad-modal-trigger", AdModalTriggerController)

